import styled from 'styled-components';

import {
  companyColor,
  defaultColor,
  device,
  fluidFont,
  font,
} from 'styles/theme';

import { EyeIcon } from 'assets/icons';

export const Table = styled.table`
  border: 1px solid ${defaultColor('background')};
  border-radius: 12px;
  width: 100%;
  min-width: 560px;
  border-spacing: 0px;
  overflow: hidden;

  @media only screen and (${device('tablet')}) {
    min-width: 520px;
  }

  @media only screen and (${device('mobileSmall')}) {
    min-width: 460px;
  }

  @media only screen and (${device('laptop')}) {
    min-width: 100%;
  }

  & > tbody > tr:last-child > td {
    border-bottom: none;
  }
`;

export const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  margin-top: 10px;
  -webkit-overflow-scrolling: touch;
`;

export const TableHeader = styled.th`
  text-align: right;
  white-space: nowrap;

  &:first-child {
    text-align: left;
    white-space: normal;
  }

  background-color: ${defaultColor('background')};
  font-family: ${font('semibold')};
  ${fluidFont('11px', '13px')};
  color: ${companyColor('font')};
  padding: 1rem 1.25rem;

  @media only screen and (${device('tablet')}) {
    padding: 0.875rem 1rem;
  }
`;

export const Cell = styled.td`
  text-align: right;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid ${defaultColor('background')};
  vertical-align: top;
  color: ${({ isBold }) => (isBold ? companyColor('font') : defaultColor('font'))};
  font-family: ${({ isBold }) => (isBold ? font('semibold') : font('regular'))};
  ${fluidFont('12px', '14px')};
  white-space: nowrap;

  min-width: ${({ sizes }) => sizes.minWidth};
  width: ${({ sizes }) => sizes.width};

  &:first-child {
    text-align: left;
    white-space: normal;
    min-width: max(180px, ${({ sizes }) => sizes.minWidth || '0px'});
  }

  @media only screen and (${device('tablet')}) {
    padding: 0.875rem 1rem;
  }

  @media only screen and (${device('mobileSmall')}) {
    padding: 0.75rem 0.875rem;
  }
`;

export const LineItemDescription = styled.div`
  color: ${defaultColor('dark')};
  white-space: pre-line;
  line-height: 1.3;
`;

export const StyledImageWrapper = styled.div`
  position: relative;
  width: 64px;
  height: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;

  @media only screen and (${device('mobileSmall')}) {
    width: 56px;
    height: 56px;
  }
`;

export const StyledImage = styled.img`
  width: 64px;
  height: 64px;
  border-radius: 2px;
  object-fit: contain;

  @media only screen and (${device('mobileSmall')}) {
    width: 56px;
    height: 56px;
  }
`;

export const Placeholder = styled.div`
  width: 64px;
  height: 64px;
  flex-shrink: 0;

  @media only screen and (${device('mobileSmall')}) {
    width: 56px;
    height: 56px;
  }
`;

export const HoverOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 2px;
  background: rgba(31, 45, 92, 0.8);

  display: flex;
  justify-content: center;
  align-items: center;

  opacity: 0;
  transition: opacity 0.3s;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      opacity: 1;
    }
  }

  @media (hover: none) {
    opacity: 1;
    background: rgba(31, 45, 92, 0.65);
  }
`;

export const IconButton = styled.button`
  background: none;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  padding: 6px;
  margin: 0;
  cursor: pointer;
  line-height: 0;

  &:focus {
    outline: none;
  }

  &:focus-visible [data-tooltip-text='true'] {
    opacity: 1;
  }
`;

export const ShowIcon = styled(EyeIcon)`
  display: block;
  width: 24px;
  height: 24px;
  stroke: ${defaultColor('white')};
  fill: ${defaultColor('white')};
`;
